<template>
  <div>
    <div class="search-wrapper">
      <div class="search">
        <span>订单编号：</span>
        <Input style="width:180px;" placeholder="模糊查询" v-model="searchForm['orderNo']"></Input>
      </div>
      <div class="search">
        <span>供应商名称：</span>
        <Input style="width:180px;" placeholder="模糊查询" v-model="searchForm['ghfCompanyName']"></Input>
      </div>
      <div class="search">
        <span>金额：</span>
        <Input style="width:200px;" v-model="searchForm['orderAmountTotal']"></Input>
      </div>
      <div class="search">
        <span>类型：</span>
        <Select style="width:160px" v-model="searchForm.orderType">
          <Option v-for="item in orderTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <Button type="primary" icon="ios-search" style="margin: 0 10px;" @click="search">搜索</Button>
      <Button icon="ios-loop-strong" type="primary" style="margin-right:5px;" @click="resetSearch">重置搜索</Button>
    </div>
    <Spin :fix="true" v-if="pageSpin"></Spin>
    <!-- 数据列表 -->
    <Table :columns="columns" :data="tableData" style="min-width:1300px;"></Table>
    <Page ref="page" @on-change="pageChange" :total="pageTotal" :current="currentPage" show-elevator show-total style="margin:5px;"></Page>
    <!-- 确认弹窗 -->
    <Modal
        v-model="showModal"
        title="提示">
        <p>确认款项信息无误后请点击通过，反之退回。</p>
        <div slot="footer">
          <Button type="error" @click="reject">退回</Button>
          <Button type="success" @click="selectShow=true">通过</Button>
        </div>
    </Modal>
    <!-- 支付时间选择 -->
    <Modal
      v-model="selectShow"
      title="确认支付时间">
      支付时间：<Date-picker type="datetime" format="yyyy-MM-dd HH:mm:ss" v-model="rPayTime" placeholder="选择支付时间" style="width: 200px"></Date-picker>
        <div slot="footer">
          <Button type="error" @click="rPayTime=null;selectShow=false">取消</Button>
          <Button type="success" @click="ok">确定</Button>
        </div>
    </Modal>
    <!-- 附件弹窗 -->
    <!-- <Modal
        v-model="showAppendix"
        title="附件信息"
        ok-text="通过"
        cancel-text="退回">
        <p>确认款项信息无误后请点击通过，反之退回。</p>
        <div slot="footer"></div>
    </Modal> -->
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

// 订单状态 0：未确认 1：已确认 2：线上支付未确认
export default {
  computed: {
    user() {
      return this.$store.state.session.user
    }
  },
  data() {
    return {
      baseUrl: 'https://api.choicelink.cn/NewFinancial',  // 接口url开头
      reportUrl: 'http://report.choicelink.cn:8082/WebReport/ReportServer?reportlet=newcailian%2Fwx%2F%28%5B65b0%5D%29%5B667a%5D%5B91c7%5D%5B9879%5D%5B76ee%5D%5B6536%5D%5B5165%5D%5B4e00%5D%5B89c8%5D.cpt&%E5%9C%B0%E5%8C%BA=',
      searchForm: {
        orderNo: '',
        ghfCompanyName: '',
        orderAmountTotal: '',
        orderType: ''
      },  //当前搜索框
      orderTypeList: [
        {
          value: '会员充值',
          label: '会员充值'
        },
        {
          value: '会员提现',
          label: '会员提现'
        },
        {
          value: '余额扣除',
          label: '余额扣除'
        },
        {
          value: '对公账号绑定',
          label: '对公账号绑定'
        },
        {
          value: '全部',
          label: '全部'
        }
      ],  //订单状态
      tableData: [],
      columns: [
        {
          title: '订单编号',
          key: 'orderNo'
        },
        {
          title: '供应商名称',
          key: 'ghfCompanyName'
        },
        {
          title: '类型',
          key: 'orderType'
        },
        {
          title: '交易时间',
          width: 168,
          align: 'center',
          render: (h, params) => {
            return params.row.payTime ? h('div', params.row.payTime.replace('T', ' ')) : h('div', '/')   // 时间格式化
          }
        },
        {
          title: '金额（元）',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let amount = params.row.orderAmountTotal || '无'
            if (amount !== '无') {
              switch (params.row.orderType) {
                case '会员充值':
                  return h('div', {
                    style: {
                      color: '#45AD4C'
                    }
                  },`+${amount}`)
                case '会员提现':
                  return h('div', {
                    style: {
                      color: '#f30'
                    }
                  },`${amount}`)
                case '余额扣除':
                  return h('div', {
                    style: {
                      color: '#f30'
                    }
                  },`${amount}`)
                case '对公账号绑定':
                  return h('div', {
                    style: {
                      color: '#45AD4C'
                    }
                  },`+${amount}`)
              }
            } else {
              return h('div', amount)
            }
          }
        },
        {
          title: '状态',
          align: 'center',
          render: (h, params) => {
            let orderStatus = params.row.orderStatus
            let auditStatus = params.row.financialCharges.auditStatus
            let status = params.row.financialCharges.status
            if (orderStatus === '2' && auditStatus == '0') {
              return h('div', {
                style: {
                  color: '#2d8cf0'
                }
              },'待审核')
            } else if (orderStatus === '2' && auditStatus == '1') {
              return h('div', {
                style: {
                  color: '#45AD4C'
                }
              },'已通过')
            } else if (orderStatus === '4' && auditStatus == '2') {
              return h('div', {
                style: {
                  color: '#f30'
                }
              },'已退回')
            }
          }
        },
        {
          title: '操作',
          width: 260,
          // align: 'center',
          render: (h, params) => {
            let orderStatus = params.row.orderStatus
            let auditStatus = params.row.financialCharges.auditStatus
            let status = params.row.financialCharges.status
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: !(orderStatus === '2' && auditStatus == '0')
                },
                on: {
                  click: () => {
                    this.currentOrder = params.row
                    this.showModal = true
                  }
                }
              }, '确认'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: !(params.row.orderType === '会员充值' || params.row.orderType === '会员提现')
                },
                style: {
                  margin: '0 5px'
                },
                on: {
                  click: () => {
                    this.currentOrder = params.row
                    // 获取附件信息
                    axios.get(`${this.baseUrl}/api/services/app/Orders/GetPublishCheck`, {
                      params: {
                        orderNo: this.currentOrder.orderNo
                      }
                    }).then(res => {
                      // this.showAppendix = true
                      if (res.data.result.data.items.length) {
                        window.open(res.data.result.data.items[0].fileUrl)
                      } else {
                        this.$Message.info('无相关附件')
                      }
                    })
                  }
                }
              }, '附件下载'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  display: params.row.orderType === '余额扣除' ? '' : 'none'
                },
                on: {
                  click: async () => {
                    this.currentOrder = params.row
                    if (!this.currentOrder.redOrderNo) {
                      this.$Message.error('暂无扣除详情')
                      return
                    }
                    // 获取扣费订单
                    let rep = await axios.get(`${this.baseUrl}/api/services/app/Orders/GetPagedInfo`,{
                      params: {
                        filter: `orderNo == "${params.row.redOrderNo}"`
                      }
                    })
                    const order = rep.data.result.items[0]
                    this.$Modal.info({
                      render: (h) => {
                        return <div>
                          <p>供应商名称：{order.ghfCompanyName}</p>
                          <p style="margin-top:12px">金额：{order.orderAmountTotal}元</p>
                          <p style="margin-top:12px">费用类型：{order.orderType}</p>
                        </div>
                      }
                    })
                    // this.showModal = true
                  }
                }
              }, '扣除详情'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  display: params.row.orderType === '会员提现' ? '' : 'none'
                },
                on: {
                  click: async () => {
                    try {
                      this.$Spin.show()
                      const left = await axios.get(`https://middleware.choicelink.cn/margin_docking/api/public/getSubAccountBalance`, {
                        params: {
                          subAcctNo: params.row.xhfBankAccount
                        }
                      })
                      this.$Message.info({
                        content: `${params.row.ghfCompanyName}账号余额：${left.data.result.amount}元`,
                        duration: 10
                      })
                    } catch (error) {
                      console.log(error)
                      this.$Message.error('查询失败')
                    } finally {
                      this.$Spin.hide()
                    }
                  }
                }
              }, '余额查询')
            ]);
          }
        }
      ],
      currentPage: 1,
      pageTotal: 0,
      showModal: false,
      currentOrder: {},
      showAppendix: false,
      selectShow: false,
      rPayTime: null
    }
  },
  async created() {
    this.init(1)
  },
  methods: {
    // 获取数据列表
    async init(page) {
      this.pageSpin = true
      let orderNo = this.searchForm.orderNo ? ` and orderNo.Contains("${this.searchForm.orderNo}")` : ''
      let ghfCompanyName = this.searchForm.ghfCompanyName ? ` and ghfCompanyName.Contains("${this.searchForm.ghfCompanyName}")` : ''
      let orderAmountTotal = this.searchForm.orderAmountTotal ? ` and orderAmountTotal=="${this.searchForm.orderAmountTotal}"` : ''
      let orderType = this.searchForm.orderType && this.searchForm.orderType !== '全部' ? ` and orderType=="${this.searchForm.orderType}"` : ''
      let query = orderNo + ghfCompanyName + orderAmountTotal + orderType
      axios.get(this.baseUrl + "/api/services/app/Orders/GetWalletPaged", {
        params: {
          filter: query.slice(5),
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      }).then(res => {
        this.pageTotal = res.data.result.totalCount
        this.tableData = res.data.result.items
        this.pageSpin = false
      }).catch(err => {
        this.$Message.error('数据请求失败！')
      })
    },
    // 分页
    pageChange(page) {
      this.tableData = []
      this.currentPage = page
      this.init(page)
    },
    // 搜索按钮
    search(e) {
      // e 判断是否组件刷新
      this.currentPage = e == '1' ? this.currentPage : 1
      this.tableData = []
      this.init(this.currentPage)
    },
    // 重置搜索
    resetSearch() {
      this.currentPage = 1
      this.searchForm = {
        page: 1,
        rows: 10,
        orderNo: '',
        ghfCompanyName: '',
        orderAmountTotal: '',
        orderType: ''
      }
      this.init(1)
    },
    ok () {
      if (!this.rPayTime) {
        this.$Message.error('请选择支付时间！')
        return
      }
      // 修改订单状态
      let order = Object.assign(this.currentOrder, {
        orderStatus: '2',
        payTime: moment(this.rPayTime).format('YYYY-MM-DD HH:mm:ss')
      })
      order.financialCharges.auditStatus = '1'
      order.financialCharges.status = '1'
      // 提现通过 更新钱包余额
      try {
        this.$Spin.show()
        axios.post(this.baseUrl + "/api/services/app/Orders/ModifyWalletChargesOrder", order).then(res => {
          if (order.orderType === '对公账号绑定') {
            axios.put('https://middleware.choicelink.cn/userCenter/api/public/company-bank-account/update',{
              companyId: order.supplierId,
              isActive: true
            })
          }
          if (order.orderType === '会员提现') {
            axios.post('https://middleware.choicelink.cn/margin_docking/api/public/refund', {
              openBankName: order.ghfBankName, // 收款账户开户行名称
              realRefundAmount: order.orderAmountTotal, // 实际退款金额
              receiveMoneyAcct: order.ghfBankAccount, // 收款人账号
              receiveMoneyBankNumber: order.ghfBankNum, // 收款账户开户行行号
              receiveMoneyName: order.ghfCompanyName, // 收款人名称
              refundAmount: order.orderAmountTotal, // 要求退款金额
              refundTime: moment().format('YYYYMMDDhhmmss'), // 要求退款时间
              subAcct: order.xhfBankAccount, // 子账号
              totalAmt: order.orderAmountTotal, // 总金额
              tkType: 1, // 1=非原路退款；2=原路退款
              totalNum: 1,
              detailInterest: '0.00',
              interest: false,
              remCharge: false,
              transferFee: '0.00'
            })
          }
          this.showModal = false
          this.selectShow = false
          this.$Spin.hide()
          this.$Message.success('已通过')
          this.init(this.currentPage)
        })
      } catch (err) {
        console.log(err)
      }
    },
    reject () {
      // 修改订单状态
      let order = Object.assign(this.currentOrder, {
        orderStatus: '4'
      })
      order.financialCharges.auditStatus = '2'
      order.financialCharges.status = '0'
      // 提现通过 更新钱包余额
      axios.post(this.baseUrl + "/api/services/app/Orders/ModifyWalletChargesOrder", order).then(res => {
        this.showModal = false
        this.$Message.success('已退回')
        this.init(this.currentPage)
      }).catch(err => {
        this.$Message.error('数据请求失败！')
      })
    }
  },
}
</script>

<style lang="less">
.search-wrapper {
  margin: 5px;
  .search {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .input-enroll {
    width: 100px;
    display: inline-block;
  }
}
</style>